// Dashboard-Widget: Kapazität diese Woche — Bar-Chart je Abteilung mit Auslastung
// A2 Feature

import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Gauge, AlertTriangle } from 'lucide-react';
import { api, type KapazitaetOverload } from '../lib/api';

export default function KapazitaetWidget() {
  const [rows, setRows] = useState<KapazitaetOverload[]>([]);
  const [overload, setOverload] = useState<number>(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let on = true;
    const load = () =>
      api.kapazitaet
        .thisWeekOverload()
        .then((r) => {
          if (on) {
            setRows(r.data);
            setOverload(r.overload_count);
            setLoading(false);
          }
        })
        .catch(() => {
          if (on) setLoading(false);
        });
    load();
    const t = setInterval(load, 30_000);
    return () => {
      on = false;
      clearInterval(t);
    };
  }, []);

  return (
    <div
      className={`bg-white rounded-lg p-4 shadow-sm border ${
        overload > 0 ? 'border-red-300' : 'border-slate-200'
      }`}
    >
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Gauge className="w-4 h-4 text-brand" />
          <h3 className="text-sm font-semibold text-slate-700">Kapazität diese Woche</h3>
          {overload > 0 && (
            <span className="inline-flex items-center gap-1 text-[10px] bg-red-100 text-red-700 px-1.5 py-0.5 rounded font-semibold">
              <AlertTriangle className="w-3 h-3" /> {overload} überlastet
            </span>
          )}
        </div>
        <Link to="/kapazitaeten" className="text-xs text-brand hover:underline">
          Planung →
        </Link>
      </div>
      {loading && <div className="text-xs text-slate-400">Lädt …</div>}
      {!loading && rows.length === 0 && (
        <div className="text-xs text-slate-400">Keine Daten</div>
      )}
      <div className="space-y-1.5">
        {rows.map((r) => {
          const pct = r.last_percent;
          const width = Math.min(pct ?? 0, 150);
          const barColor =
            pct === null
              ? 'bg-slate-300'
              : pct < 80
              ? 'bg-emerald-500'
              : pct < 100
              ? 'bg-amber-500'
              : pct < 120
              ? 'bg-orange-500'
              : 'bg-red-600';
          return (
            <div key={r.abteilung_id} className="flex items-center gap-2 text-xs">
              <span className="w-24 truncate font-medium text-slate-700" title={r.name}>
                {r.name}
              </span>
              <div className="flex-1 h-4 rounded bg-slate-100 overflow-hidden relative">
                <div
                  className={`h-full ${barColor} transition-all`}
                  style={{ width: `${width * 0.66}%` }}
                />
              </div>
              <span className="w-12 text-right tabular-nums font-semibold">
                {r.stunden_soll > 0 ? `${pct ?? 0}%` : '—'}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
